import { twMerge } from 'tailwind-merge';

import { useEnrollmentStatusTranslation } from '@/data/hook/useEnrollmentStatusTranslation';
import { EnrollmentStatusEnum } from '@/models/Enrollment';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Tag from '@/components/ui/custom/dataDisplay/Tag';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';

type EnrollmentTagProps = {
  status: EnrollmentStatusEnum;
  className?: string;
};

export default function EnrollmentTag({
  status,
  className,
}: EnrollmentTagProps) {
  const translatedStatus = useEnrollmentStatusTranslation(status);

  const enrollmentStatus = [
    EnrollmentStatusEnum.AWAITING_PAYMENT,
    EnrollmentStatusEnum.CONCLUDED,
  ];

  const renderEnrollmentTag = enrollmentStatus.includes(status);

  return (
    <ConditionalRenderer condition={renderEnrollmentTag}>
      <Tooltip
        text={translatedStatus}
        classNameContainer="truncate w-full max-w-[20%]"
      >
        <Tag
          color="warning"
          className={{
            base: twMerge(
              'py-1 px-2 rounded-full text-12 flex text-center',
              className,
            ),
          }}
          text={translatedStatus}
        />
      </Tooltip>
    </ConditionalRenderer>
  );
}
